import {StylesConfig} from 'react-select';

export function defaultSelectStyles<
  Option,
  IsMulti extends boolean,
>(): StylesConfig<Option, IsMulti> {
  return {
    container: (base) => ({
      ...base,
      flexGrow: 1,
    }),
    control: (base) => ({
      ...base,
      border: '1px solid #EBE8EA',
      borderRadius: '0.375rem', // corresponds to Chakra medium
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isFocused ? '#EDF2FD' : '',
      color: 'inherit',
      ':hover': {
        backgroundColor: '#EDF2FD',
      },
    }),
  };
}

export function errorSelectStyles<Option, IsMulti extends boolean>(
  error: boolean
): StylesConfig<Option, IsMulti> {
  return {
    ...defaultSelectStyles<Option, IsMulti>(),
    control: (base) => ({
      ...base,
      borderColor: error ? 'kred.200' : base.borderColor,
      boxShadow: error
        ? '0 0 0 1px var(--chakra-colors-kred-200)'
        : base.boxShadow,
      ...(error
        ? {
            '&:hover': {
              borderColor: 'red',
            },
          }
        : {}),
    }),
  };
}
